import * as t from "io-ts"

export const TSlotAvailability = t.string;

export type SlotAvailability = t.TypeOf<typeof TSlotAvailability>